import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { publicAxios } from '@/lib/axios'
import { handleApiError, MutationConfig } from '@/lib/react-query'
import { PublicDto } from '@/types'

const signinUser = (data: PublicDto['SigninUserCommand']): Promise<PublicDto['AuthSessionDto']> => {
  return publicAxios.post('/auth/signin', data)
}

export type UseSigninUserOptions = {
  config?: MutationConfig<typeof signinUser>
}

export const useSigninUser = ({ config }: UseSigninUserOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: signinUser,
    onSuccess: (data, vars, onRes, ctx) => {
      config?.onSuccess?.(data, vars, onRes, ctx)
    },
    onError: (error: AxiosError<PublicDto['ExceptionDetails']>, vars, onRes, ctx) => {
      handleApiError(error)
      config?.onError?.(error, vars, onRes, ctx)
    },
  })
}
